<script setup>
import { computed, onMounted, ref } from 'vue';
import { Collapse, PhxIcon } from '@phx-styleguides/pia';

const props = defineProps({
  isExpanded: {
    type: Boolean,
    default: false,
  },
  id: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    default: '',
  },
});

const sectionFilterRef = ref(null);
const collapsibleId = computed(() => `accordion-filter-${props.id}`);
const dataCy = computed(() => `accordion-${props.id}`);

onMounted(() => {
  if (sectionFilterRef.value) {
    new Collapse(sectionFilterRef.value);
  }
});
</script>

<template>
  <li class="accordion__item" :data-cy="dataCy">
    <button
      aria-expanded="false"
      class="btn btn--bare accordion__btn"
      :data-target="`#${collapsibleId}`"
      data-toggle="collapse"
      data-cy="accordion-collapse-button"
      type="button"
    >
      {{ title }}
      <span class="btn__icon btn__icon--end">
        <phx-icon icon="chevron-down" :title="title" class="icon--sm" />
      </span>
    </button>

    <div
      :id="collapsibleId"
      ref="sectionFilterRef"
      :class="{ 'is-expanded': isExpanded }"
      class="collapse accordion__collapse"
    >
      <div class="accordion__collapse-body">
        <slot />
      </div>
    </div>
  </li>
</template>
